module.exports = __webpack_public_path__ + "img/logo2aa.89b75fe9.png";